<template>
  <div class="message-confirmation mb-4">

    <div class="row row-tabs mt-3">
      <div class="col-12 confirmation-title mb-2">
        <h1 class="text-center">Alle Antworten</h1>
        <button @click="$router.go(-1)" class="go-back btn-cursor" type="button" name="button">
          <img class="ml-4" :src="'./static/img/' + user.role +'/nav_back.png'" alt="">
        </button>
      </div>

      <div class="col-12">
        <div v-for="messageRespond in messageResponds" class="single-confirmation confirmed" style="border-bottom: 1px solid #ddd;">
          <p>{{ messageRespond.sender.title }}</p>
          <button class="btn-cursor" @click="showModal(messageRespond)" type="button" name="button">
            <img v-if="messageRespond.unread" width="32" height="32" class="icon-message" :src="'./static/img/' + user.role +'/message_text.png'" alt="">
            <img v-else width="32" height="32" class="icon-message" :src="'./static/img/' + user.role +'/message_text_readed.png'" alt="">
          </button>
        </div>
      </div>

    </div>

    <b-modal ref="confirmationMsgModal" size="md" centered class="app-modals" hide-footer>
      <div slot="modal-title" class="w-100">
        Von: {{ modalTitle }}
      </div>
      {{ modalMsg }}
    </b-modal>

  </div>
</template>

<script>
import messageApi from '@/api/v1/messages';

export default {
  data() {
    return {
      user: this.$current_user,
      messageResponds: {},
      modalMsg: '',
      modalTitle: '',
    };
  },
  methods: {
    showModal(respondMsg) {
      this.modalMsg = respondMsg.message;
      this.modalTitle = respondMsg.confirmed_by.title;
      this.$refs.confirmationMsgModal.show();
      if (respondMsg.unread) {
        messageApi.openReply(respondMsg.itemid);
        // eslint-disable-next-line
        respondMsg.unread = false;
      }
    },
  },
  created() {
    messageApi.show((data) => {
      this.messageResponds = data.detailresponse.answers;
    }, this.$route.params.id);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/Show/Responds.vue